import React from 'react';
import Icon from '../Icon/Icon';
import './RadioSelect.scss';

const Option = ({ inline, value, label, optionValue, onChange }) => {
  const handleChange = () => {
    onChange(optionValue);
  };

  return (
    <label className={inline ? 'inline' : ''} key={optionValue}>
      <input
        value={optionValue}
        checked={value === optionValue}
        onChange={handleChange}
        type="radio"
      />
      <span className="label__text">
        <span className="label label__check">
          <Icon name={'check'} />
        </span>
        <span>{label}</span>
      </span>
    </label>
  );
};
export const RadioSelectNotRedux = ({ options, onChange, onSelect, value, inline }) => {
  return (
    <div className={'radio-circle'}>
      {options.map((option) => (
        <Option
          key={option.value}
          inline={inline}
          value={value}
          label={option.label}
          optionValue={option.value}
          onChange={onChange}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};
